var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container text-center"},[_c('h2',[_vm._v("404 Page Not Found")]),_c('h3',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Return home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }